<div class="user-profile-wrapper">
  <div
    class="flex flex-row items-center"
    [class.justify-center]="!showName"
    [class.pl-4]="showName"
  >
    <div
      [style.background-image]="userData.photoLink ? 'url(' + userData.photoLink + ')' : ''"
      class="avatar w-8 h-8 rounded-full flex items-center justify-center text-white font-bold"
    >
      <span class="text-white text-xs">{{ getInitials() }}</span>
    </div>
    <span *ngIf="showName" class="user-name text-sm truncate ml-2">
      {{ userData.name }}
    </span>
  </div>
</div>
